import React, { Fragment } from "react";
// import styles from "./EV54DashboardMobileView.module.css";

const EV54DashboardMobileView = ({ Graphs }) => {
  return <Fragment>{Graphs}</Fragment>;
};

export default EV54DashboardMobileView;
